export const alertTypes = {
  success: 'success',
  error: 'error',
  info: 'info',
  warning: 'warning'
};
